export type FormValues = {
    moduleId: string;
    dealerId: string;
    modelIds: string[];
    subModelIds: string[];
    variantIds: string[];

    // This field just for the form
    modelId: string;
    subModelId: string;
    variantId: string;
};

export const ALL_OPTION = 'ALL';

export const defaultValue = {
    moduleId: null,
    dealerId: null,
    modelId: null,
    subModelId: null,
    variantId: null,
    modelIds: [],
    subModelIds: [],
    variantIds: [],
};
